//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'
import { dxValidationGroupResult } from 'devextreme/ui/validation_group'
import { AsyncRule, CompareRule, CustomRule, EmailRule, NumericRule, PatternRule, RangeRule, RequiredRule, StringLengthRule } from 'devextreme/ui/validation_engine'

//#endregion

import { TypeHelper, LocalizationHelper, EventsNames, TemplateHelper, ConfigHelper, Dictionary, ConvertHelper, ToastHelper } from "../../../../helpers"
import { BackwardCompatibilityHelper } from '../../../../../app/helpers/backward-compatibility-helper'
import { DescrType } from '../../../../../app/modules/common/select-add-descr/select-add-descr.directive'
import { KingspanConfigurationFormService } from '../service'
import { DictionaryKeyType, KeyType } from '../../../../../app/helpers/dictionary'
import { LocationService } from '../../../../services/location'
import { UserSessionService } from '../../../../services/user-session'
import { idCustromInstallationCategory } from '../service/kingspan-configuration-form.service'
import { Enums } from "../../../../models/common"
import { OpDataType, OpDevice, OpData, OpDescr } from "../../../../models/core"
import { OpReferenceTypeObject, OpEnumObject } from "../../../../models/custom"
import { IOpData, IReferenceType } from '../../../../models/util/interfaces'
import { OpDataList } from '../../../../models/util'
import { LocationConfigurationFormKingspanOptions } from '../kingspan-configuration-form.interfaces'
import { DescrModel } from '../../../../../app/modules/api/api.models'
import { IMRIIMRInstallationCategoryPopupOptions, IIMRInstallationCategoryPopup, IIMRInstallationCategoryPopupInitializedArgs } from '../ks-inst-cat-cr-ed-popup/ks-inst-cat-cr-ed-popup.interfaces'
import { IIMRConfirmationPopup, IMRConfirmationPopupInitializedArgs, IMRConfirmationPopupOptions } from '../../../../modules/common/confirmation-popup2'
import { OpInstallationCategory } from '../../../../models/custom/op-installation-category'

const ACTION_SCHEDULE_MODE: number = 2 //defauls hardcoded value for kingspan
type DxValidationRule = (RequiredRule | NumericRule | RangeRule | StringLengthRule | CustomRule | CompareRule | PatternRule | EmailRule | AsyncRule)

export class KingspanDeviceFormController implements ng.IComponentController {
    private options: LocationConfigurationFormKingspanOptions
    private referenceTypeId: number = Enums.ReferenceType.SerialNbr

    private event: any

    private isLoading: boolean = true

    private deviceSerialNbr: number = null
    private opDevice: OpDevice
    private form: DevExpress.ui.dxForm
    private deviceFormOptions: DevExpress.ui.dxFormOptions
    private formData: { [key: number]: any } = {}
    private previouseFormData: { [key: number]: any } = {}

    private locationInstalationCategory: number
    private locationInstalationCategoryText: string
    private locationInstalationCategoryOptions: DevExpress.ui.dxSelectBoxOptions
    private noDevice: boolean
    private deviceText: string

    private sendActionButtonOptions: DevExpress.ui.dxButtonOptions
    private sendActionText: string

    private udiDescriptions: OpDescr[]
    private customDescriptionsDict: Dictionary<OpDescr>
    private customDescriptions: OpDescr[] = []
    private currentCustomDescription: { [key: number]: DescrModel } = {}

    private categoryContextMenuOptions: DevExpress.ui.dxContextMenuOptions
    private contextMenuTarget: string = 'kingspan-category-item'
    private contextMenuTargetContainer: string = 'kingspan-category-item-template-container'
    private contextMenuDataSource: DevExpress.ui.dxContextMenuItem[]

    private installationCategoryPopupOptions: IMRIIMRInstallationCategoryPopupOptions
    private installationCategoryPopup: IIMRInstallationCategoryPopup
    private selectedCategoryRMB: number
    private confirmationPopupOptions: IMRConfirmationPopupOptions
    private confirmationPopup: IIMRConfirmationPopup

    private categories: OpInstallationCategory[]
    private installaTionCategoryComponent: DevExpress.ui.dxSelectBox

    private descrValidationRulles: { [key: number]: DxValidationRule[] }
    private formValidationGroupOptions: DevExpress.ui.dxValidationGroupOptions
    private formValidationGroup: DevExpress.ui.dxValidationGroup

    constructor(
        private $scope: ng.IScope,
        private userSession: UserSessionService,
        private locationService: LocationService,
        private kingspanService: KingspanConfigurationFormService
    ) {
        this.setEvents()
    }

    //#region IComponentController Implementation
    public $onChanges(changes: { [index: string]: ng.IChangesObject<any> }): void {
        if (TypeHelper.isOptionsDefined(changes)) {
            this.initialize()
        }
    }

    public $onDestroy(): void {
        if (this.event != null) {
            this.event() //destroy event
        }
        this.locationInstalationCategory = null
        this.deviceFormOptions = null
        this.deviceSerialNbr = null
        this.opDevice = null
        this.categoryContextMenuOptions = null
    }
    //#endregion IComponentController Implementation End

    private initialize(): void {
        this.customDescriptionsDict = new Dictionary<OpDescr>(null, KeyType.Number)
        this.getUdiDescriptions()
        this.resetFormData()
        this.getConnectedDevice()
        this.kingspanService
            .getCategoriesWithUdiDescriptions()
            .then((categories: OpInstallationCategory[]) => {
                this.categories = categories
                this.setOptions()
            })
    }

    private setEvents = (): void => {
        this.event = this.$scope.$root.$on(EventsNames.SUBMIT_LOCATION_CONFIGURATION_KINGSPAN, () => {
            if (this.locationInstalationCategory === idCustromInstallationCategory) {
                this.updateFormItemsState()
            }

            setTimeout(() => {
                const isDeviceValid: boolean = this.validateDeviceData()
                this.options.onValidationCallback(isDeviceValid)

                if (isDeviceValid === true) {
                    if (this.locationInstalationCategory === idCustromInstallationCategory) {
                        if (this.customDescriptionsDict.length > 0) {
                            this.kingspanService
                                .saveDescriptions(this.customDescriptionsDict.values())
                                .then((result: OpDescr[]) => {

                                    this.customDescriptionsDict.keys().forEach((key: DictionaryKeyType) => {

                                        const customDescr: OpDescr = this.customDescriptionsDict.tryGetValue(key)
                                        let idDescr: number

                                        result.every((descr: OpDescr, index: number, array: OpDescr[]) => {
                                            if (descr.description == customDescr.description) {
                                                idDescr = descr.idDescr
                                                array.splice(index, 1)
                                                return false
                                            }
                                            return true
                                        })

                                        if (idDescr != null) {
                                            switch (key) {
                                                case Enums.DataType.DEVICE_UDI_DESCRIPTION_1:
                                                    this.formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_1_ID_DESCR] = idDescr
                                                    break
                                                case Enums.DataType.DEVICE_UDI_DESCRIPTION_2:
                                                    this.formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_2_ID_DESCR] = idDescr
                                                    break
                                                case Enums.DataType.DEVICE_UDI_DESCRIPTION_3:
                                                    this.formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_3_ID_DESCR] = idDescr
                                                    break
                                                case Enums.DataType.DEVICE_UDI_DESCRIPTION_4:
                                                    this.formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_4_ID_DESCR] = idDescr
                                                    break
                                            }
                                        }
                                    })

                                    this.options.onSubmitCallback(this.prepareDeviceData())
                                })
                                .fail((error: any) => {
                                    const errorMsg: string = ConvertHelper.getRequestErrorMessage(error)
                                    ToastHelper.showError(errorMsg || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
                                })
                        } else {
                            this.options.onSubmitCallback(this.prepareDeviceData())
                        }
                    } else {
                        this.options.onSubmitCallback(this.prepareDeviceData())
                    }
                }
            })
        })
    }

    private getDafaultItem(dataType: OpDataType): DevExpress.ui.dxFormSimpleItem {
        const item: DevExpress.ui.dxFormSimpleItem = {
            cssClass: this.getCssClassName(dataType.idDataType),
            name: dataType.idDataType.toString(),
            dataField: dataType.idDataType.toString(),
            label: {
                text: dataType.toString()
            },
            validationRules: [{
                type: 'pattern',
                pattern: ''
            }]
        }

        return item
    }

    private setOptions(): void {
        this.deviceText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Device)
        this.sendActionText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendAction)

        this.sendActionButtonOptions = {
            bindingOptions: {
                disabled: '$ctrl.noDevice'
            },
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendAction),
            template: TemplateHelper.getIcon(ConfigHelper.Icon.DEVICES, this.userSession),
            onClick: (e: any) => this.onRunAction(e)
        }

        this.formValidationGroupOptions = {
            onInitialized: (e: any) => {
                this.formValidationGroup = e.component
            },
        }

        this.userSession
            .getDataProvider()
            .DataType
            .getDataTypes(this.kingspanService.getKingspanDedicatedFormDataTypesList())
            .then((dataTypes: OpDataType[]) => {
                const formItems: DevExpress.ui.dxFormSimpleItem[] = []
                const promises: JQueryPromise<DevExpress.ui.dxFormSimpleItem>[] = []

                dataTypes.forEach((dataType: OpDataType) => {
                    if (dataType.idDataType !== Enums.DataType.LOCATION_INSTALLATION_CATEGORY) {
                        const item: DevExpress.ui.dxFormSimpleItem = this.getDafaultItem(dataType)

                        if (dataType.idDataType === Enums.DataType.ACTION_SCHEDULE_MODE) {
                            item.visible = false
                        }

                        const promise: JQueryDeferred<DevExpress.ui.dxFormSimpleItem> = $.Deferred<DevExpress.ui.dxFormSimpleItem>()

                        switch (dataType.idDataTypeClass) {
                            case Enums.DataTypeClass.Boolean:
                                item.editorType = 'dxCheckBox'
                                item.editorOptions = <DevExpress.ui.dxCheckBoxOptions>{
                                    onValueChanged: (e: any) => { this.onValueChanged(e, dataType.idDataType) },
                                }
                                promise.resolve(item)
                                break

                            case Enums.DataTypeClass.Text:
                                item.editorType = 'dxTextBox'
                                promise.resolve(item)
                                break

                            case Enums.DataTypeClass.Decimal:
                            case Enums.DataTypeClass.Integer:
                            case Enums.DataTypeClass.Real:
                                if (dataType.idReferenceType == null) {
                                    item.editorType = 'dxNumberBox'
                                    promise.resolve(item)
                                } else {
                                    item.editorType = 'dxSelectBox'

                                    item.editorOptions = <DevExpress.ui.dxSelectBoxOptions>{
                                        valueExpr: 'id',
                                        searchEnabled: true,
                                        displayExpr: 'caption',
                                        noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                                        placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),

                                        onValueChanged: (e: any) => { this.onValueChanged(e, dataType.idDataType) },
                                    }

                                    this.getReferenceTable(dataType.idReferenceType).then((table: { id: number, caption: string }[]) => {
                                        (<DevExpress.ui.dxSelectBoxOptions>item.editorOptions).dataSource = table
                                        promise.resolve(item)
                                        return promise.promise()
                                    })
                                }
                                break
                        }

                        promises.push(promise.promise())
                    } else {
                        const table: OpDescr[] = _.map(this.categories, (category: OpInstallationCategory) => {
                            return category.installationCategory
                        })

                        // this.getReferenceTable(dataType.idReferenceType).then((table: { id: number, caption: string }[]) => {
                        this.locationInstalationCategoryText = dataType.toString()
                        this.locationInstalationCategoryOptions = {
                            bindingOptions: {
                                disabled: '$ctrl.noDevice',
                                value: '$ctrl.formData[' + dataType.idDataType + ']'
                            },
                            valueExpr: 'idDescr',
                            searchEnabled: true,
                            displayExpr: 'description',
                            noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                            placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                            dataSource: table,
                            itemTemplate: 'category',

                            onInitialized: (e: any) => { this.onInstallationCategorySelectBoxInited(e) },
                            onValueChanged: (e: any) => { this.onValueChanged(e, dataType.idDataType) }
                        }
                        // })
                    }
                })

                $.when(...promises).then((...items) => {
                    formItems.push(...items)

                    let contentReady: boolean = false

                    this.deviceFormOptions = {
                        colCount: 5,
                        bindingOptions: {
                            formData: '$ctrl.formData',
                        },
                        items: formItems,
                        scrollingEnabled: true,
                        labelLocation: 'top',
                        onInitialized: (e: any) => { this.onFormInitialized(e) },
                        onContentReady: (e: any) => {
                            if (!contentReady) { //to avoid all items reinit few times
                                this.onFormContentReady(e)
                                contentReady = true
                            }
                        }
                    }
                })
            })

        this.contextMenuDataSource = [{
            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Add),
            icon: 'add',
            disabled: false,
        }, {
            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Edit),
            icon: 'edit',
            disabled: true
        }, {
            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Delete),
            icon: 'trash',
            disabled: true
        }]

        this.categoryContextMenuOptions = {
            target: `.${this.contextMenuTargetContainer}`,
            dataSource: this.contextMenuDataSource,
            showEvent: 'dxcontextmenu',
            onShowing: (e: any) => {
                this.onContextMenuShowing(e)
            },
            onItemClick: (e: any) => {
                this.onContextMenuItemClick(e)
            }
        }

        this.installationCategoryPopupOptions = {
            onInitialized: (e: IIMRInstallationCategoryPopupInitializedArgs) => {
                this.installationCategoryPopup = e.component
            },
            onSubmit: (toSave: OpInstallationCategory): JQueryPromise<void> => {
                return this.onInstallationCategoryCreateEditSubmit(toSave)
            }
        }

        this.confirmationPopupOptions = {
            title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Deletion),
            content: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ConfirmDeleteInstallationCategory),

            onInitialized: (e: IMRConfirmationPopupInitializedArgs) => {
                this.confirmationPopup = e.component
            },

            onConfirmed: () => {
                this.onConfirmDelete()
            }
        }
    }

    private onContextMenuShowing(e: any): void {
        this.selectedCategoryRMB = null
        const event: JQuery.Event = e.jQEvent
        const targetNode: HTMLElement = event['currentTarget']
        const target: HTMLElement = targetNode.querySelector(`.${this.contextMenuTarget}`)

        if (target != null && target.id != null) {
            this.selectedCategoryRMB = +target.id

            this.setDisableStateContextMenuItems(this.kingspanService.isDescrInCommonInstallationCategoryRange(this.selectedCategoryRMB))
        } else {
            this.setDisableStateContextMenuItems(true)
        }

        e.component.option('dataSource', this.contextMenuDataSource)
    }

    private onContextMenuItemClick(e: any): void {
        const event: JQuery.Event = e.jQEvent

        if (e.itemData != null) {
            if (e.itemData.text == LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Delete)) {
                this.confirmationPopup.show()
            } else {
                if (this.installationCategoryPopup != null) {
                    if (e.itemData.text == LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Edit)) {
                        this.installationCategoryPopup.showPopup(_.find(this.categories, (categpry: OpInstallationCategory) => categpry.installationCategory.idDescr == this.selectedCategoryRMB))
                    } else {
                        this.installationCategoryPopup.showPopup()
                    }
                }
            }
        }
    }

    private setDisableStateContextMenuItems(isDisabled: boolean): void {
        _.forEach(this.contextMenuDataSource, (item: DevExpress.ui.dxContextMenuItem) => {
            if (item.text == LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Edit) ||
                item.text == LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Delete)) {
                item.disabled = isDisabled
            }
        })
    }

    private onInstallationCategoryCreateEditSubmit(toSave: OpInstallationCategory): JQueryPromise<void> {
        return this.kingspanService
            .saveInstallaTionCategory(toSave)
            .then((response: OpInstallationCategory) => {
                if (this.categories == null) {
                    this.categories = []
                }

                if (response.installationCategory != null) {

                    if (toSave.installationCategory.opState == Enums.OpChangeState.New) {
                        this.categories.push(response)
                    } else {
                        const editedCategory: OpInstallationCategory = _.find(this.categories, (category: OpInstallationCategory) => {
                            return category.installationCategory.idDescr == response.installationCategory.idDescr
                        })

                        if (editedCategory != null) {
                            editedCategory.installationCategory = response.installationCategory
                            editedCategory.deviceUdiDescriptions = _.sortBy(response.deviceUdiDescriptions, (udi: OpDescr) => { return udi.idDescr })
                        }
                    }

                    this.updateFormItemsState()
                    this.installaTionCategoryComponent.option('dataSource', _.map(this.categories, (category: OpInstallationCategory) => {
                        return category.installationCategory
                    }))
                }

                ToastHelper.showSuccess(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.InstallationCategorySaved))

                return
            })
            .fail((error: any) => {
                const errorMessage: string = ConvertHelper.getRequestErrorMessage(error)

                ToastHelper.showError(errorMessage || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
            })
    }

    private onInstallationCategorySelectBoxInited(e: any): void {
        this.installaTionCategoryComponent = e.component
    }

    private onConfirmDelete(): void {
        this.confirmationPopup.popup.hide()

        this.isLoading = true
        const toDelete: OpInstallationCategory = _.find(this.categories, (categpry: OpInstallationCategory) => categpry.installationCategory.idDescr == this.selectedCategoryRMB)
        toDelete.installationCategory.opState = Enums.OpChangeState.Delete

        this.kingspanService
            .saveInstallaTionCategory(toDelete)
            .then(() => {
                if (this.categories == null) {
                    this.categories = []
                }

                this.categories = _.filter(this.categories, (category: OpInstallationCategory) => {
                    return category.installationCategory.idDescr != toDelete.installationCategory.idDescr
                })

                this.installaTionCategoryComponent.option('dataSource', _.map(this.categories, (category: OpInstallationCategory) => { return category.installationCategory }))

                ToastHelper.showSuccess(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.InstallationCategoryDeleted))
            })
            .fail((error: any) => {
                const errorMessage: string = ConvertHelper.getRequestErrorMessage(error)

                ToastHelper.showError(errorMessage || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
            })
            .always(() => {
                this.isLoading = false
            })
    }

    private getConnectedDevice = (): void => {
        this.opDevice = null
        const device: OpDevice = this.options.opLocation != null ? _.first(this.options.opLocation.currentDevices) : null
        this.noDevice = device == null

        if (device != null) {
            this.deviceSerialNbr = device.serialNbr
            this.opDevice = device
        } else {
            if (this.form != null) {
                this.form.option({ disabled: true })
            }
        }
    }

    private onRunAction = (e: any): void => {
        if (this.options.onRunAction != null) {
            this.options.onRunAction(this.prepareDeviceData())
        }
    }

    private onFormInitialized = (e: any): void => {
        this.form = e.component

        if (this.opDevice == null) {
            this.form.option({ disabled: true })
        }

        this.updateFormItemsState()
    }

    private onFormContentReady(e: any) {
        if (this.noDevice == true) {
            this.isLoading = false
        }

        this.onUdiFieldChanged()
    }

    private onValueChanged = (e: any, idDataType: number): void => {
        switch (idDataType) {
            case Enums.DataType.LOCATION_INSTALLATION_CATEGORY:
                this.locationInstalationCategory = e.value

                if (this.form != null) {
                    this.form.option({ disabled: !this.locationInstalationCategory })
                }

                if (e.value != e.previousValue) {
                    if (e.previousValue != null) {
                        this.resetUdiDescriptions()
                    }

                    this.updateFormItemsState()
                    this.onUdiFieldChanged()
                }
                break

            case Enums.DataType.DEVICE_UDI_ENABLED_1:
                this.onDeviceUdiChanged(this.getDeviceUdiEnabledNumber(Enums.DataType.DEVICE_UDI_ENABLED_1), !e.value)
                break
            case Enums.DataType.DEVICE_UDI_ENABLED_2:
                this.onDeviceUdiChanged(this.getDeviceUdiEnabledNumber(Enums.DataType.DEVICE_UDI_ENABLED_2), !e.value)
                break
            case Enums.DataType.DEVICE_UDI_ENABLED_3:
                this.onDeviceUdiChanged(this.getDeviceUdiEnabledNumber(Enums.DataType.DEVICE_UDI_ENABLED_3), !e.value)
                break
            case Enums.DataType.DEVICE_UDI_ENABLED_4:
                this.onDeviceUdiChanged(this.getDeviceUdiEnabledNumber(Enums.DataType.DEVICE_UDI_ENABLED_4), !e.value)
                break
        }
    }

    private onDeviceUdiChanged = (num: number, disabled: boolean): void => {
        if (this.form != null) {
            if ((this.locationInstalationCategory != null && disabled == false) || disabled == true) {
                if (this.locationInstalationCategory != null && this.locationInstalationCategory != idCustromInstallationCategory) {
                    const editor: DevExpress.ui.Editor = this.form.getEditor(Enums.DataType[`DEVICE_UDI_DESCRIPTION_${num}`].toString())

                    if (editor != null) {
                        this.form.getEditor(Enums.DataType[`DEVICE_UDI_DESCRIPTION_${num}`].toString()).option('disabled', disabled)
                    }
                }

                this.form.getEditor(Enums.DataType[`DEVICE_UDI_CONFIGURATION_${num}`].toString()).option('disabled', disabled)

                if (disabled == true) {
                    this.previouseFormData[Enums.DataType[`DEVICE_UDI_DESCRIPTION_${num}`]] = this.formData[Enums.DataType[`DEVICE_UDI_DESCRIPTION_${num}`]]
                    this.previouseFormData[Enums.DataType[`DEVICE_UDI_CONFIGURATION_${num}`]] = this.formData[Enums.DataType[`DEVICE_UDI_CONFIGURATION_${num}`]]

                    this.formData[Enums.DataType[`DEVICE_UDI_DESCRIPTION_${num}`]] = null
                    this.formData[Enums.DataType[`DEVICE_UDI_CONFIGURATION_${num}`]] = null

                    this.currentCustomDescription[Enums.DataType[`DEVICE_UDI_DESCRIPTION_${num}`]] = null
                    this.formData[Enums.DataType[`DEVICE_UDI_DESCRIPTION_${num}_ID_DESCR`]] = null
                } else {
                    if (this.previouseFormData[Enums.DataType[`DEVICE_UDI_DESCRIPTION_${num}`]] !== undefined) {
                        this.formData[Enums.DataType[`DEVICE_UDI_DESCRIPTION_${num}`]] = this.previouseFormData[Enums.DataType[`DEVICE_UDI_DESCRIPTION_${num}`]]
                    }
                    if (this.previouseFormData[Enums.DataType[`DEVICE_UDI_CONFIGURATION_${num}`]] !== undefined) {
                        this.formData[Enums.DataType[`DEVICE_UDI_CONFIGURATION_${num}`]] = this.previouseFormData[Enums.DataType[`DEVICE_UDI_CONFIGURATION_${num}`]]
                    }
                }
            }
        }
    }

    private onDeviceUdiSelectionChanged(e: any, idDataType: Enums.DataType): void {
        let selectedId: number = null

        if (e.selectedItem != null) {
            selectedId = e.selectedItem.idDescr
        }

        switch (idDataType) {
            case Enums.DataType.DEVICE_UDI_DESCRIPTION_1:
                this.formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_1_ID_DESCR] = selectedId
                break
            case Enums.DataType.DEVICE_UDI_DESCRIPTION_2:
                this.formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_2_ID_DESCR] = selectedId
                break
            case Enums.DataType.DEVICE_UDI_DESCRIPTION_3:
                this.formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_3_ID_DESCR] = selectedId
                break
            case Enums.DataType.DEVICE_UDI_DESCRIPTION_4:
                this.formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_4_ID_DESCR] = selectedId
                break
        }
    }

    private onUdiFieldChanged(): void {
        this.onDeviceUdiChanged(this.getDeviceUdiEnabledNumber(Enums.DataType.DEVICE_UDI_ENABLED_1), !this.formData[Enums.DataType.DEVICE_UDI_ENABLED_1])
        this.onDeviceUdiChanged(this.getDeviceUdiEnabledNumber(Enums.DataType.DEVICE_UDI_ENABLED_2), !this.formData[Enums.DataType.DEVICE_UDI_ENABLED_2])
        this.onDeviceUdiChanged(this.getDeviceUdiEnabledNumber(Enums.DataType.DEVICE_UDI_ENABLED_3), !this.formData[Enums.DataType.DEVICE_UDI_ENABLED_3])
        this.onDeviceUdiChanged(this.getDeviceUdiEnabledNumber(Enums.DataType.DEVICE_UDI_ENABLED_4), !this.formData[Enums.DataType.DEVICE_UDI_ENABLED_4])
    }

    private getReferenceTable(idReferenceType): JQueryPromise<{ id: number; caption: string; }[]> {
        return this.userSession
            .getDataProvider().System
            .getDictionaries([idReferenceType], true)
            .then((dictionaries: Dictionary<Dictionary<IReferenceType>>) => {
                if (dictionaries != null && dictionaries.containsKey(idReferenceType) && dictionaries.tryGetValue(idReferenceType) != null) {

                    switch (idReferenceType) {
                        case Enums.ReferenceType.IdLocationInstallationCategory:
                            const categories: OpReferenceTypeObject[] = dictionaries.tryGetValue(idReferenceType).values() as OpReferenceTypeObject[]

                            return _.map(categories, (category: OpReferenceTypeObject) => {
                                return {
                                    id: category.getReferenceKey(),
                                    caption: category.getDescription()
                                }
                            })

                        default:
                            const values: OpEnumObject[] = dictionaries.tryGetValue(idReferenceType).values() as OpEnumObject[]

                            return _.map(values, (value: OpEnumObject) => {
                                return {
                                    id: value.getReferenceKey(),
                                    caption: value.toString()
                                }
                            })
                    }
                }

                return []
            })
            .fail(() => {
                return []
            })
    }

    /**change device event */
    public onPopoverValueIdSelected = (valueId: number): void => {
        this.deviceSerialNbr = valueId
        this.noDevice = this.deviceSerialNbr == null

        if (valueId != null) {
            this.getDevice(valueId)
        } else {
            this.opDevice = null
            this.formData = {}
            this.form.option({ disabled: true })
        }
    }

    private getDevice(idDevice: number): void {
        this.isLoading = true
        this.userSession
            .getDataProvider()
            .Device.getDevice(idDevice)
            .then((device: OpDevice) => {
                this.opDevice = device

                this.resetFormData()

                setTimeout(() => {
                    device.dataList.toArray().forEach((data: OpData) => {
                        if (this.kingspanService.getKingspanDedicatedFormDataTypesList().concat(...this.kingspanService.getKingspanDedicatedFormHiddenDataTypesList()).indexOf(data.idDataType) > -1) {
                            this.formData[data.idDataType] = data.value

                            if (data.idDataType === Enums.DataType.LOCATION_INSTALLATION_CATEGORY) {
                                this.locationInstalationCategory = data.value
                            }
                        }
                    })

                    if (_.size(this.udiDescriptions) > 0) {
                        for (let itemData in this.formData) {
                            if (itemData != null && this.kingspanService.getKingspanDedicatedFormHiddenDataTypesList().indexOf(+itemData) > -1) {
                                const descr: OpDescr = _.find(this.udiDescriptions, (item: OpDescr) => item.idDescr == this.formData[itemData])

                                if (descr != null) {
                                    switch (+itemData) {
                                        case Enums.DataType.DEVICE_UDI_DESCRIPTION_1_ID_DESCR:
                                            this.formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_1] = descr.description
                                            this.currentCustomDescription[Enums.DataType.DEVICE_UDI_DESCRIPTION_1] = descr
                                            break
                                        case Enums.DataType.DEVICE_UDI_DESCRIPTION_2_ID_DESCR:
                                            this.formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_2] = descr.description
                                            this.currentCustomDescription[Enums.DataType.DEVICE_UDI_DESCRIPTION_2] = descr
                                            break
                                        case Enums.DataType.DEVICE_UDI_DESCRIPTION_3_ID_DESCR:
                                            this.formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_3] = descr.description
                                            this.currentCustomDescription[Enums.DataType.DEVICE_UDI_DESCRIPTION_3] = descr
                                            break
                                        case Enums.DataType.DEVICE_UDI_DESCRIPTION_4_ID_DESCR:
                                            this.formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_4] = descr.description
                                            this.currentCustomDescription[Enums.DataType.DEVICE_UDI_DESCRIPTION_4] = descr
                                            break
                                    }
                                }
                            }
                        }
                    }

                    if (this.form != null) {
                        this.form.option({ disabled: !this.locationInstalationCategory })
                        this.updateFormItemsState()
                        this.form.repaint()
                    }

                    this.onUdiFieldChanged()

                    this.isLoading = false
                })
            })
    }

    private resetFormData = (): void => {
        this.formData = {}
        this.formData[Enums.DataType.DEVICE_UDI_ENABLED_1] = false
        this.formData[Enums.DataType.DEVICE_UDI_ENABLED_2] = false
        this.formData[Enums.DataType.DEVICE_UDI_ENABLED_3] = false
        this.formData[Enums.DataType.DEVICE_UDI_ENABLED_4] = false
        this.formData[Enums.DataType.ACTION_SCHEDULE_MODE] = ACTION_SCHEDULE_MODE
    }

    private validateDeviceData(): boolean {
        if (this.opDevice != null && this.form != null) {
            const validateGroup: dxValidationGroupResult = this.formValidationGroup.validate()
            const validationResult: dxValidationGroupResult = this.form.validate()

            if (validationResult != null && validateGroup != null) {
                return validationResult.isValid && validateGroup.isValid
            } else {
                if (validationResult == null && validateGroup != null) {
                    return validateGroup.isValid
                }

                if (validateGroup == null && validationResult != null) {
                    return validationResult.isValid
                }
            }
        }

        return true
    }

    private prepareDeviceData = (): OpDevice => {
        if (this.opDevice != null) {
            const dataList: OpDataList<OpData> = new OpDataList<OpData>()
            const formData: { [key: number]: any } = this.form.option('formData')

            for (const item in formData) {
                if (item != null) {
                    const data: OpData = _.find(this.opDevice.dataList.toArray(), (itemData: OpData) => itemData.idDataType == +item)

                    let opState: Enums.OpChangeState = Enums.OpChangeState.New
                    let idData: number = 0

                    if (data != null) {
                        opState = Enums.OpChangeState.Modified
                        idData = data.idData

                        if (data.value == formData[item]) {
                            opState = Enums.OpChangeState.Loaded
                        }
                    }

                    const objectDataToSave: IOpData = <IOpData>{}
                    objectDataToSave.idData = idData
                    objectDataToSave.idDataType = +item
                    objectDataToSave.value = formData[item]
                    objectDataToSave.opState = opState
                    dataList.push(<OpData>objectDataToSave)
                }
            }

            this.opDevice.dataList = dataList

            this.opDevice.opState = Enums.OpChangeState.Modified
        }
        return this.opDevice
    }

    private resetUdiDescriptions(): void {
        this.formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_1] = null
        this.previouseFormData[Enums.DataType.DEVICE_UDI_DESCRIPTION_1] = null
        this.formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_1_ID_DESCR] = null
        this.previouseFormData[Enums.DataType.DEVICE_UDI_DESCRIPTION_1_ID_DESCR] = null
        this.formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_2] = null
        this.previouseFormData[Enums.DataType.DEVICE_UDI_DESCRIPTION_2] = null
        this.formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_2_ID_DESCR] = null
        this.previouseFormData[Enums.DataType.DEVICE_UDI_DESCRIPTION_2_ID_DESCR] = null
        this.formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_3] = null
        this.previouseFormData[Enums.DataType.DEVICE_UDI_DESCRIPTION_3] = null
        this.formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_3_ID_DESCR] = null
        this.previouseFormData[Enums.DataType.DEVICE_UDI_DESCRIPTION_3_ID_DESCR] = null
        this.formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_4] = null
        this.previouseFormData[Enums.DataType.DEVICE_UDI_DESCRIPTION_4] = null
        this.formData[Enums.DataType.DEVICE_UDI_DESCRIPTION_4_ID_DESCR] = null
        this.previouseFormData[Enums.DataType.DEVICE_UDI_DESCRIPTION_4_ID_DESCR] = null

        this.currentCustomDescription[Enums.DataType.DEVICE_UDI_DESCRIPTION_1] = null
        this.currentCustomDescription[Enums.DataType.DEVICE_UDI_DESCRIPTION_2] = null
        this.currentCustomDescription[Enums.DataType.DEVICE_UDI_DESCRIPTION_3] = null
        this.currentCustomDescription[Enums.DataType.DEVICE_UDI_DESCRIPTION_4] = null
    }

    private updateFormItemsState(): void {
        if (this.form != null) {
            const isEditable: boolean = this.deviceSerialNbr && !!this.locationInstalationCategory

            if (this.locationInstalationCategory !== idCustromInstallationCategory) {
                // let dataSource: { name: string, id: number | string }[] = []
                // if (this.locationInstalationCategory === this.kingspanService.getLocationInstalationCategories().GreaseSeparators) {
                //     dataSource = this.kingspanService.getGreaseSeparatorsList(this.udiDescriptions)
                // } else if (this.locationInstalationCategory === this.kingspanService.getLocationInstalationCategories().OilSeparators) {
                //     dataSource = this.kingspanService.getOilSeparatorsList(this.udiDescriptions)
                // } else if (this.locationInstalationCategory === this.kingspanService.getLocationInstalationCategories().PumpStation) {
                //     dataSource = this.kingspanService.getPumpStationList(this.udiDescriptions)
                // } else if (this.locationInstalationCategory === this.kingspanService.getLocationInstalationCategories().SewageTreatmentPlant) {
                //     dataSource = this.kingspanService.getSewageTreatmentPlantList(this.udiDescriptions)
                // }

                const currentInstallationCategory: OpInstallationCategory = _.find(this.categories, (category: OpInstallationCategory) => {
                    if (category == null || category.installationCategory == null) {
                        return false
                    }

                    return category.installationCategory.idDescr == this.locationInstalationCategory
                })

                const dataSource: OpDescr[] = currentInstallationCategory != null && currentInstallationCategory.deviceUdiDescriptions != null
                    ? currentInstallationCategory.deviceUdiDescriptions
                    : []

                const getOptions = (idDataType: number): DevExpress.ui.dxFormSimpleItem => {
                    const options: DevExpress.ui.dxFormSimpleItem = {
                        editorType: 'dxSelectBox',
                        editorOptions: <DevExpress.ui.dxSelectBoxOptions>{
                            elementAttr: {
                                id: "table" + idDataType,
                                'table-id': idDataType
                            },
                            dataSource: dataSource,
                            valueExpr: 'description',
                            searchEnabled: true,
                            displayExpr: 'description',
                            placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                            noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                            onSelectionChanged: (e: any) => { this.onDeviceUdiSelectionChanged(e, idDataType) },
                            disabled: !isEditable,
                        },
                        validationRules: [{
                            type: 'required',
                            message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RequiredField)
                        }],
                        template: null,
                        isRequired: true,
                    }

                    return options
                }

                this.form.itemOption(Enums.DataType.DEVICE_UDI_DESCRIPTION_1.toString(), getOptions(Enums.DataType.DEVICE_UDI_DESCRIPTION_1))
                this.form.itemOption(Enums.DataType.DEVICE_UDI_DESCRIPTION_2.toString(), getOptions(Enums.DataType.DEVICE_UDI_DESCRIPTION_2))
                this.form.itemOption(Enums.DataType.DEVICE_UDI_DESCRIPTION_3.toString(), getOptions(Enums.DataType.DEVICE_UDI_DESCRIPTION_3))
                this.form.itemOption(Enums.DataType.DEVICE_UDI_DESCRIPTION_4.toString(), getOptions(Enums.DataType.DEVICE_UDI_DESCRIPTION_4))
            } else {
                const getDescrFieldOptions = (idDataType: number): DevExpress.ui.dxFormSimpleItem => {
                    if (this.descrValidationRulles == null) {
                        this.descrValidationRulles = {}
                    }

                    this.descrValidationRulles[idDataType] = this.getValidationRulles(idDataType)

                    const options = <DevExpress.ui.dxFormSimpleItem>{
                        dataField: idDataType.toString(),
                        name: idDataType.toString(),
                        isRequired: true,
                        validationRules: [{
                            type: 'required',
                            message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RequiredField)
                        }],
                        template: '<select-add-descr disabled="!$ctrl.formData[' + Enums.DataType[`DEVICE_UDI_ENABLED_${this.getDeviceUdiEnabledNumberByUdiDesciption(idDataType)}`] + ']" current="$ctrl.currentCustomDescription[' + idDataType + ']" descriptions="$ctrl.customDescriptions" element-id="' + idDataType + '" property-name="' + idDataType + '" type="' + DescrType.ItemType + '" callback="$ctrl.onDescrSelectionChanged" validation-rulles="$ctrl.descrValidationRulles[' + idDataType + ']"></select-add-descr>'
                    }

                    return options
                }

                this.form.itemOption(Enums.DataType.DEVICE_UDI_DESCRIPTION_1.toString(), getDescrFieldOptions(Enums.DataType.DEVICE_UDI_DESCRIPTION_1))
                this.form.itemOption(Enums.DataType.DEVICE_UDI_DESCRIPTION_2.toString(), getDescrFieldOptions(Enums.DataType.DEVICE_UDI_DESCRIPTION_2))
                this.form.itemOption(Enums.DataType.DEVICE_UDI_DESCRIPTION_3.toString(), getDescrFieldOptions(Enums.DataType.DEVICE_UDI_DESCRIPTION_3))
                this.form.itemOption(Enums.DataType.DEVICE_UDI_DESCRIPTION_4.toString(), getDescrFieldOptions(Enums.DataType.DEVICE_UDI_DESCRIPTION_4))
            }
        }
    }

    private getValidationRulles(idDataType: Enums.DataType): DxValidationRule[] {
        return [
            {
                type: "custom", //'required',//
                message: LocalizationHelper.getLocalizedText(
                    LocalizationHelper.Text.RequiredField
                ),

                validationCallback: (e: any) => {
                    if (this.formData[Enums.DataType[`DEVICE_UDI_ENABLED_${this.getDeviceUdiEnabledNumberByUdiDesciption(idDataType)}`]] == true) {
                        return e.value != null
                    }

                    return true
                }
            },
        ]
    }

    private getCssClassName(idDataType: number): string {
        return 'data_type_id_' + idDataType
    }

    private getDeviceUdiEnabledNumber(idDataType: Enums.DataType): number {
        return this.kingspanService.getDeviceUdiEnabledNumber(idDataType)
    }

    private getDeviceUdiEnabledNumberByUdiDesciption(idDataType: Enums.DataType): number {
        return this.kingspanService.getDeviceUdiEnabledNumberByUdiDesciption(idDataType)
    }

    private getUdiDescriptions() {
        this.kingspanService
            .getUdiDescriptions()
            .then((result: OpDescr[]) => {
                this.udiDescriptions = result
            })
    }

    /**select-add-descr callback */
    private onDescrSelectionChanged = (elementId: number, propertyName: string, descr: DescrModel): void => {
        const opDescr: OpDescr = BackwardCompatibilityHelper.DescrModelToOpDescr(descr)
        opDescr.extendedDescription = Enums.ReferenceType[Enums.ReferenceType.IdDeviceUdiDescription]

        this.customDescriptionsDict.addOrUpdate(elementId, opDescr)

        this.currentCustomDescription[elementId] = opDescr
        this.formData[elementId] = opDescr.description
    }
}